module.exports = __webpack_public_path__ + "img/unknown.460f1753.svg";